import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import JwtService from "@/core/services/jwt.service";
import store from "@/core/services/store";
import { REFRESH_ACCESS_TOKEN } from "@/core/services/store/auth.module";

/**
 * Service to call HTTP request via Axios
 */
const ApiService = {
  init() {
    Vue.use(VueAxios, axios);
    Vue.axios.defaults.baseURL = process.env.VUE_APP__OLINQUAAPI;
  },

  /**
   * Set the default HTTP request headers
   */
  setHeader() {
    Vue.axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${JwtService.getToken()}`;
  },

  query(resource, params) {
    // this is a WIP function - the console logging is here so I can see what happens when tokens expire (MM 29/10/20)
    // console.log(JSON.stringify(Vue.axios.defaults.baseURL));
    // console.log(JSON.stringify(resource));

    this.setHeader();
    //console.log(JSON.stringify(Vue.axios.defaults.headers.common));

    let result = Vue.axios.get(resource, params).catch((error) => {
      if (error.message.includes("401")) {
        console.log("401 caught - trying to get a new token");
        store.dispatch(REFRESH_ACCESS_TOKEN).then(() => {
          console.log("finished trying to get a new token - trying API again");

          result = Vue.axios.get(resource, params).catch((error) => {
            console.log("retry failed");
            throw new Error(`[KT] ApiService ${error}`);
          });
        });
      } else {
        throw new Error(`[KT] ApiService ${error}`);
      }
    });

    return result;
  },

  /**
   * Send the GET HTTP request
   * @param resource
   * @param slug
   * @returns {*}
   */
  get(resource, slug = "") {
    return Vue.axios.get(`${resource}/${slug}`).catch((error) => {
      throw new Error(`[KT] ApiService ${error}`);
    });
  },

  /**
   * Set the POST HTTP request
   * @param resource
   * @param params
   * @returns {*}
   */
  post(resource, content) {
    this.setHeader();
    //console.log(JSON.stringify(Vue.axios.defaults.headers.common));

    let result = Vue.axios.post(resource, content).catch((error) => {
      if (error.message.includes("401")) {
        console.log("401 caught - trying to get a new token");
        store.dispatch(REFRESH_ACCESS_TOKEN).then(() => {
          console.log("finished trying to get a new token - trying API again");

          result = Vue.axios.get(resource, params).catch((error) => {
            console.log("retry failed");
            throw new Error(`[KT] ApiService ${error}`);
          });
        });
      } else {
        throw new Error(`[KT] ApiService ${error}`);
      }
    });

    return result;
  },

  /**
   * Send the UPDATE HTTP request
   * @param resource
   * @param slug
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  update(resource, slug, params) {
    return Vue.axios.put(`${resource}/${slug}`, params);
  },

  /**
   * Send the PUT HTTP request
   * @param resource
   * @param params
   * @returns {IDBRequest<IDBValidKey> | Promise<void>}
   */
  put(resource, params) {
    return Vue.axios.put(`${resource}`, params);
  },

  /**
   * Send the DELETE HTTP request
   * @param resource
   * @returns {*}
   */
  delete(resource) {
    return Vue.axios.delete(resource).catch((error) => {
      // console.log(error);
      throw new Error(`[RWV] ApiService ${error}`);
    });
  },
};

export default ApiService;
